/**
 * Banner Model
 */

define(function(require, exports, module) {
    'use strict';

    var _ = require('underscore');
    var core = require('core');
    var HeaderView = require('portlets/header/header.view');
    var PortletModel = require('modules/portlet/portlet.model');
    var device = require('util/device.util');
    var language = require('util/language.util');
    var user = require('user');
    var urlUtil = require('util/url.util');
    var config = require('config');

    module.exports = PortletModel.extend({

        initialize: function() {
            PortletModel.prototype.initialize.apply(this, arguments);

            this._setData();
        },

        subscribe: function() {
            this.listenTo(core, {
                'auth:login auth:logout user:toggleBalance page:refresh app:initialResourcesLoaded': this._setData
            });

            this.listenTo(user, {
                'change:showLowBalancePopup change:lowBalanceHighlight': this._setData
            });
        },

        getView: function(options) {
            return new HeaderView(_.extend({}, options, { model: this }));
        },

        _setData: function() {
            const isDesktopHeader = device.formFactor === 'desktop';
            const isItalianRegulationEnabled = config.get('regulation') === 'italian';
            const pagesConf = this.preparePredefinedPages();
            const hideBalanceByUrl = urlUtil.getLocationParameterByName('showHeaderOnlyOnMobile') === '1';
            const isShowSidebar = config.get('isShowSidebar');

            this.set(
                _.extend({}, user.toJSON(), pagesConf, {
                    isDesktopHeader: isDesktopHeader,
                    isWebChatEnabled: isDesktopHeader && config.get('supportChatEnableWeb'),
                    isItalianRegulationEnabled: isItalianRegulationEnabled,
                    showAdditionalUserInfo: isItalianRegulationEnabled && user.get('role') === 'user',
                    isHidden: false,
                    isShowSidebar: isShowSidebar,
                    lang: language.getTwoLetterLanguage(user.get('lang')),
                    t: config.get('requestStamp'),
                    hideBalanceByUrl
                })
            );
        },

        preparePredefinedPages: function() {
            var account = getVal('accountPage');
            var lang = getVal('languagePage');
            var registration = getVal('registrationURL');
            var balance = getVal('balancePage');

            function getVal(propName) {
                var val = config.get(propName);
                return val ? val.trim() : '';
            }

            return {
                availabilityPredefinedPages: {
                    account: Boolean(account),
                    language: Boolean(lang),
                    registration: Boolean(registration),
                    balance: Boolean(user.get('showLowBalancePopup') || balance)
                },
                predefinedPages: {
                    account: account,
                    language: lang,
                    registration: registration,
                    balance: balance
                }
            };
        }
    });
});
